import { MobileKalender } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/mobile';
import { KalenderWeekPicker } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/mobile/components/KalenderWeekPicker';
import {
  faFilter,
  faLayerGroup,
  faUserGroup,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { SortierungButton } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/components/SortierungButton.tsx';
import {
  Badge,
  Button,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@e2n/ui/v2';
import { useState } from 'react';
import { useRotationsplanFeatureContext } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/RotationsplanFeatureContext';
import { BerufeFilter } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/components/Filter/BerufeFilter';
import { LehrjahrFilter } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/components/Filter/LehrjahrFilter';
import { StandorteFilter } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/components/Filter/StandorteFilter';
import { Uebersicht } from '@/domain/mitarbeiter/features/rotationsplan/features/Plaene/Uebersicht';
import { View } from '@/domain/mitarbeiter/features/rotationsplan/entities/views';
import { VorlagenUebersicht } from '@/domain/mitarbeiter/features/rotationsplan/features/Vorlagen/Uebersicht';
import { KalenderLoading } from '@/domain/mitarbeiter/features/rotationsplan/components/KalenderLoading';

/* eslint-disable max-lines-per-function */
export function MobilePage({
  view,
  isStandorteUpdatePending,
}: {
  view: string;
  isStandorteUpdatePending: boolean;
}) {
  const [kalenderFilterOptionsVisible, setKalenderFilterOptionsVisible] =
    useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const {
    store: {
      ui: {
        kalender: { filter: kalenderFilter },
        uebersicht: { filter: uebersichtFilter },
      },
      setKalenderView,
    },
  } = useRotationsplanFeatureContext();

  let selectedFilterCount = 0;
  if (view === 'planung') {
    Object.values(kalenderFilter).forEach((filter) => {
      if (filter.length > 0) {
        selectedFilterCount += 1;
      }
    });
  } else {
    Object.values(uebersichtFilter).forEach((filter) => {
      if (filter.length > 0) {
        selectedFilterCount += 1;
      }
    });
  }

  return (
    <>
      {view === 'planung' && (
        <div className="sticky top-0 z-10">
          <KalenderWeekPicker />
        </div>
      )}
      <Tabs
        className="p-4"
        value={view}
        onValueChange={(value) => {
          navigate(`/mitarbeiter/rotationsplaene/${value}`);
        }}>
        <div className="flex justify-between w-full">
          <TabsList className="w-full" variant="on-grey">
            <TabsTrigger className="grow basis-0" value="planung">
              {t('domain.mitarbeiter.rotationsplan.tabs.planung')}
            </TabsTrigger>
            <TabsTrigger className="grow basis-0" value="uebersicht">
              {t('domain.mitarbeiter.rotationsplan.tabs.rotationsplaene')}
            </TabsTrigger>
            {/* <TabsTrigger className="grow basis-0" value="vorlagen">
              {t('domain.mitarbeiter.rotationsplan.tabs.vorlagen')}
            </TabsTrigger> */}
          </TabsList>
        </div>

        <TabsContent value="planung">
          <Tabs
            className="flex flex-col gap-4"
            defaultValue="mitarbeiter_rotationsplanKalenderByArbeitsbereiche">
            <div className="flex flex-col items-start gap-4">
              <TabsList variant="on-grey">
                <Tooltip>
                  <TooltipTrigger>
                    <TabsTrigger
                      onClick={() => setKalenderView('byArbeitsbereiche')}
                      value="mitarbeiter_rotationsplanKalenderByArbeitsbereiche">
                      <FontAwesomeIcon
                        className="size-3.5!"
                        icon={faLayerGroup}
                      />
                    </TabsTrigger>
                  </TooltipTrigger>
                  <TooltipContent>
                    {t(
                      'domain.mitarbeiter.rotationsplan.tabs.anzeigeNachArbeitsbereichenTooltip',
                    )}
                  </TooltipContent>
                </Tooltip>
                <Tooltip>
                  <TooltipTrigger
                    onClick={() => setKalenderView('byMitarbeiter')}>
                    <TabsTrigger value="mitarbeiter_rotationsplanKalenderByMitarbeiter">
                      <FontAwesomeIcon
                        className="size-3.5!"
                        icon={faUserGroup}
                      />
                    </TabsTrigger>
                  </TooltipTrigger>
                  <TooltipContent>
                    {t(
                      'domain.mitarbeiter.rotationsplan.tabs.anzeigeNachMitarbeitendenTooltip',
                    )}
                  </TooltipContent>
                </Tooltip>
              </TabsList>
              <div className="flex items-center gap-2">
                <Button
                  className="gap-2"
                  variant="ghost"
                  onClick={() =>
                    setKalenderFilterOptionsVisible(
                      !kalenderFilterOptionsVisible,
                    )
                  }>
                  <FontAwesomeIcon className="size-4" icon={faFilter} />
                  {t('domain.mitarbeiter.rotationsplan.filter.label')}
                  <Badge className="bg-neutrals-v2-300 text-labels-primary">
                    {selectedFilterCount}
                  </Badge>
                </Button>
                <SortierungButton view={view as View} />
              </div>
            </div>
            {kalenderFilterOptionsVisible && (
              <div className="flex items-center gap-2 overflow-auto">
                <BerufeFilter view={view as View} />
                <LehrjahrFilter view={view as View} />
                <StandorteFilter view={view as View} />
              </div>
            )}
            <div className="relative">
              <TabsContent
                asChild
                value="mitarbeiter_rotationsplanKalenderByArbeitsbereiche">
                <MobileKalender view="arbeitsbereiche" />
              </TabsContent>
              <TabsContent
                asChild
                value="mitarbeiter_rotationsplanKalenderByMitarbeiter">
                <MobileKalender view="mitarbeiter" />
              </TabsContent>
              {isStandorteUpdatePending && <KalenderLoading />}
            </div>
          </Tabs>
        </TabsContent>
        <TabsContent className="flex flex-col gap-4" value="uebersicht">
          <Uebersicht />
        </TabsContent>
        <TabsContent className="flex flex-col gap-4" value="vorlagen">
          <VorlagenUebersicht />
        </TabsContent>
      </Tabs>
    </>
  );
}
